import http, { checkResponse, handleApiResponse } from "@/services/http";
import ApiResponse from "@/models/ApiResponse";
import BankExtractImport from "../models/BankExtractImport";
import BankExtractImportItem from "../models/BankExtractImportItem";
import ImportFormat from "../models/ImportFormat";
import Bank from "@/modules/bank/models/Bank";

export default class BankExtractImportApi {
  static get(headID: number): Promise<BankExtractImport> {
    return http.get<ApiResponse<BankExtractImport>>(`bank-extract-import/${headID}`).then(handleApiResponse);
  }

  static getLastDate(headID: number): Promise<boolean> {
    return http.post<ApiResponse<boolean>>(`bank-extract-import/extract-import-last-date`, { BankExtractID: headID }).then(handleApiResponse);
  }

  static import(headID: number, openBal: number, openRate: number): Promise<any> {
    return http.post<ApiResponse<any>>(`bank-extract-import/extract-import-to-bank`, { BankExtractID: headID, OpenBal: openBal, OpenRate: openRate }).then(handleApiResponse);
  }

  static getItems(headID: number): Promise<BankExtractImportItem[]> {
    return http
      .get<ApiResponse<BankExtractImportItem[]>>(`bank-extract-import/${headID}/items`)
      .then(handleApiResponse);
  }

  static update(bankExtractImport: BankExtractImport): Promise<boolean> {
    return http.put(`bank-extract-import`, { bankExtractImport: bankExtractImport }).then(checkResponse);
  }

  static delete(headID: number): Promise<boolean> {
    return http.delete(`bank-extract-import/${headID}`).then(checkResponse);
  }

  static prepareCheck(bankExtractImport: BankExtractImport): Promise<string> {
    return http
      .put<ApiResponse<string>>(`bank-extract-import/prepare`, {
        bankExtractImport: bankExtractImport,
      })
      .then(handleApiResponse);
  }

  static createPartBank(itemID: number, iban: string, accountNumber: string, partner: number, bank: number, currency: string, native: boolean): Promise<boolean> {
    return http
      .post<ApiResponse<boolean>>(`bank-extract-import/create-partbank`, {
        itemID: itemID,
        iban: iban,
        accountNumber: accountNumber,
        bank: bank,
        currency: currency,
        partner: partner,
        native: native
      })
      .then(checkResponse);
  }

  static prepareToImport(bankExtractImport: BankExtractImport): Promise<boolean> {
    return http
      .put(`bank-extract-import/prepare`, {
        bankExtractImport: bankExtractImport,
        confirmed: true,
      })
      .then(checkResponse);
  }

  static createImportStatement(file: File, bank: number, type: number, techAmount: number): Promise<boolean> {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("bank", bank.toString());
    formData.append("type", type.toString());
    formData.append("technicalAmount", techAmount.toString());
    return http
      .post(`bank-extract-import/create`, formData, { headers: { "Content-Type": "multipart/mixed" } })
      .then(checkResponse);
  }

  static getImportChoices(bankId: number): Promise<ImportFormat[]> {
    return http.get<ApiResponse<ImportFormat[]>>(`bank-extract-import/choices/${bankId}`).then(handleApiResponse);
  }

  static getAll(): Promise<Bank[]> {
    return http.get<ApiResponse<Bank[]>>(`bank`).then(handleApiResponse);
  }

}
